import React from "react";
import sharedUtils from "../grid/sharedUtilities";
import { AxiosResponse } from "axios";
import ManageDocumentsGridService from "../../services/ManageDocumentsGridService";
import { NullableDate } from "../grid/AddEditPopUpUtilities";
import paymentFormUtils, { ActionType, PaymentFormData } from "../Payments/PaymentFormUtils";
import PaymentService, { logicAppPostRequest, paymentCycleStatus, paymentStatus } from "../../services/PaymentService";
import { LoadPanel } from "devextreme-react";

interface PaymentInvoiceSectionProps {
    paymentCycleId: number;
    paymentData: PaymentFormData;
    onPaymentProduced: (status: string, statusId: string, isRestartDisable: boolean) => void;
    statusId: string;
    invoiceSentDate: NullableDate;
    syncDateFields: (date: NullableDate, type: string) => void;
    calculationsObject: any;
    viewDisabled: boolean;
}

interface PaymentInvoiceSectionState {
    loadPanelVisible: boolean;
    disableInvoiceButton: boolean;
    disableSentButton: boolean;
    statusIdOnClick: string;
    downloadLink: string;
    downloadLinkCss: string;
    paymentFormData: PaymentFormData;
    errorMessage: [];
}

class PaymentInvoiceSection extends React.Component<PaymentInvoiceSectionProps> {
    state: PaymentInvoiceSectionState;
    PaymentService: PaymentService;
    paymentFormUtils: paymentFormUtils;
    sharedUtils: sharedUtils;
    documentService: ManageDocumentsGridService;

    constructor(props: PaymentInvoiceSectionProps) {
        super(props);
        this.PaymentService = new PaymentService();
        this.paymentFormUtils = new paymentFormUtils();
        this.sharedUtils = new sharedUtils();
        this.state = {
            loadPanelVisible: false,
            disableInvoiceButton: false,
            disableSentButton: false,
            statusIdOnClick: "",
            downloadLink: "",
            downloadLinkCss: "icon-btn",
            paymentFormData: this.props.paymentData,
            errorMessage: [],
        };
        this.documentService = new ManageDocumentsGridService();
    }

    //Function which is invoked when the "Produce" as well as "Sent" button is clicked.
    onPaymentProduced = (statusId: string, status: string) => {
        let data: PaymentFormData = this.paymentFormUtils.paymentDataInitializePaymentItems(
            this.props,
            statusId,
            status
        );
        this.setState({
            gridData: data,
            loadPanelVisible: true,
            statusIdOnClick: statusId,
        });
        this.onSubmit(data);
    };

    onSubmit = (paymentData: PaymentFormData) => {
        var paymentCycleSubmitRequest = this.paymentFormUtils.convertFormDataToPaymentCycleRequest(
            paymentData,
            ActionType.Save,
            "",
            ""
        );
        this.PaymentService.postPaymentCycleDataV2(paymentCycleSubmitRequest)
            // .then(this.handleSuccess)
            .then(res => this.handleSuccess(res,paymentData))
            .catch(this.handleFailure);
    };

    handleSuccess = (response: AxiosResponse<any>,paymentData:PaymentFormData) => {
        const { paymentCycleId } = this.props;
        const { statusIdOnClick } = this.state;

        this.setState(
            (prevState: PaymentInvoiceSectionState) => ({
                loadPanelVisible: false,
                disableInvoiceButton: true,
                downloadLinkCss: "icon-btn",
                errorMessage: [],
            }),
            () => this.props.onPaymentProduced(paymentData.status, statusIdOnClick, false)
        );
        if (statusIdOnClick == paymentStatus.PaymentAdviseRequested) {
            let postObject: logicAppPostRequest = {
                PaymentCycleId: paymentCycleId.toString(),
            };
            this.PaymentService.triggerLogicAppForPaymentAdviceRequest(postObject);
        }
    };

    handleFailure = (error: any) => {
        var { statusIdOnClick } = this.state;
        var respMessage: string = "postPaymentCycleInvoice failed with response: " + JSON.stringify(error);

        if (!this.PaymentService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
        this.setState({
            errorMessage: error.response !== null ? JSON.parse(JSON.stringify(error.response.data.error)) : null,
            loadPanelVisible: false,
            disableInvoiceButton: false,
            downloadLinkCss:
                statusIdOnClick == paymentCycleStatus.PaymentPackRequested ? "disabled icon-btn" : "icon-btn",
        });
    };

    //Inside the update function, when the Sent date is changed in the form, it would reflect here and vice versa.
    componentDidUpdate = (prevProps: PaymentInvoiceSectionProps) => {
        if (this.props.invoiceSentDate != prevProps.invoiceSentDate) {
            this.setState({
                billingFormData: {
                    ...this.state.paymentFormData,
                    invoiceSentDate: this.props.invoiceSentDate,
                },
            });
        }
    };

    render() {
        var viewDisabled: boolean = this.props.viewDisabled;
        var invoiceButtonText: string = "SEND INVOICES";
        var { statusId } = this.props;
        var { disableInvoiceButton } = this.state;
        if (statusId && statusId == paymentStatus.PaymentAdviseRequested) {
            invoiceButtonText = "SENDING INVOICES";
        } else if (
            statusId &&
            (statusId == paymentStatus.PaymentAdvised ||
                statusId == paymentStatus.PaymentSettled ||
                statusId == paymentStatus.PaymentRemittanceRequested ||
                statusId == paymentStatus.PaymentRemitted)
        ) {
            invoiceButtonText = "INVOICE SENT";
        }
        var invoiceButtonCssClass: string =
            this.props.viewDisabled ||
            disableInvoiceButton ||
            statusId == paymentStatus.PaymentAdvised ||
            statusId == paymentStatus.PaymentAdviseRequested ||
            statusId == paymentStatus.PaymentSettled ||
            statusId == paymentStatus.PaymentRemittanceRequested ||
            statusId == paymentStatus.PaymentRemitted
                ? "btn disabledCycleButtonColor btn--large"
                : "btn saveCycleButtonColor btn--large";
        var disablePaymentInvoiceButton: boolean =
            disableInvoiceButton ||
            statusId == paymentStatus.PaymentAdvised ||
            statusId == paymentStatus.PaymentAdviseRequested ||
            statusId == paymentStatus.PaymentSettled ||
            statusId == paymentStatus.PaymentRemittanceRequested ||
            statusId == paymentStatus.PaymentRemitted
                ? true
                : false;
        return (
            <div className="card my-3">
                <div className="card-body">
                    <h4>
                        <b>Email Invoice</b>
                    </h4>
                    <>
                        <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                        <div className="row align-items-center">
                            <div className="col-2">
                                <button
                                    className={(viewDisabled ? "disabled " : "") + invoiceButtonCssClass}
                                    type="button"
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        this.onPaymentProduced(
                                            paymentStatus.PaymentAdviseRequested,
                                            paymentCycleStatus.PaymentAdviseRequested
                                        );
                                    }}
                                    disabled={viewDisabled ? true : disablePaymentInvoiceButton}
                                >
                                    {invoiceButtonText}
                                </button>
                            </div>
                            <div className="col-2">
                                    <button
                                    className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                    //className={(viewDisabled ? "disabled " : "") + invoiceButtonCssClass}
                                    type="button"
                                    onClick={(e: React.MouseEvent) => {
                                        e.preventDefault();
                                        this.onPaymentProduced(
                                            paymentStatus.PaymentAdvised,
                                            paymentCycleStatus.PaymentAdvised
                                        );
                                    }}
                                    disabled={viewDisabled ? true : disablePaymentInvoiceButton}>
                                    SKIP
                                </button>
                                </div>
                        </div>
                    </>
                </div>
            </div>
        );
    }
}
export default PaymentInvoiceSection;
